import React, { useState, useEffect } from 'react';
import { isAuthenticated } from "../../store/action/auth";
import { 
    createToken, 
    deleteTokens, 
    getTokens,
    getIntegrations, 
    deleteIntegrations,
    fetchKeyPaymentData,
    extendKey
} from "../../store/action/key";
import { getWebhooks } from "../../store/action/webhook";
import moment from 'moment';
import KeyTable from "./components/KeyTable";
import WebhookTable from "./components/WebhookTable";
import axios from 'axios';
import Modal from "../../components/molecules/Modal"
import PaymentWarning from "../../components/warnings/Payment";
import {trackEvent} from "../../services/analytics";
import TestDataWarning from "../../components/warnings/TestData";
import { getUser } from "../../store/action/user";
import { API } from "../../config";
import { connect } from 'react-redux'
import { useDispatch } from "react-redux";
import SubscriptionModal from './components/organisms/SubscriptionModal';
import { Button } from '../../components/buttons';
import QRCode from "qrcode.react";
import ShopifyCard from "./components/organisms/ShopifyCard";
import WooCard from "./components/organisms/WooCard";
import GudangIoCard from "./components/organisms/GudangCard";
import {
    getWallet
} from "../../store/action/billing";

const Setting = (props) => {
    const dispatch = useDispatch();
    const [ loading, setLoading ] = useState(true);
    const [ loadingExtendKey, setLoadingExtendKey ] = useState({woo:false,shopify:false});
    const [ loadingCreateKey, setLoadingCreateKey ] = useState(false);
    const [ showModal, setShowModal ] = useState(false);
    const [ qrModal, setQrModal ] = useState(false);
    const [ qrCode, setQrCode ] = useState('');
    const [ callbackURL, setCallbackURL ] = useState('');
    const [ subsModal, setSubsModal ] = useState(false);
    const [ subsModalType, setSubsModalType ] = useState(false);
    const [ testData, setTestData ] = useState(localStorage.getItem('biteship_test_data')||'notActive') 
    const [ tokens, setTokens ] = useState({
        app:[],
        woo:[],
        shopify:[],
        gudangio:[]
    });
    const [ integrations, setIntegrations ] = useState([]);
    const [ webhooks, setWebhooks ] = useState([])
    const [ values, setValues ] = useState({
        name:'',
        type:''
    });

    const { token, user } = isAuthenticated();

    useEffect(() => {
        _fetchData()
    }, []);

    const _fetchData = async () => {
        try {
            const environment = testData == 'active' ? 'development' : 'production';
            const resTok = await getTokens(token,environment);
            const resInt = await getIntegrations(token);
            const resWeb = await getWebhooks(environment);
            const resUs = await getUser(user._id,token)
            dispatch(getWallet(token));

            if (resInt.success) {
                setIntegrations(resInt.integrations)
            }

            if (resWeb.success) {
                setWebhooks(resWeb.webhooks)
            }

            if (resTok.tokens.length > 0) {
                
                let resTokens = resTok.tokens.reduce((result, i, idx) => {
                    console.log(i)
                    if (!(
                        i.restrictions[0].type.includes('woocommerce') || 
                        i.restrictions[0].type.includes('shopify') ||
                        i.restrictions[0].type.includes('gudangio')
                    )) {
                        result.push({
                            id: i._id,
                            name: i.name,
                            source: i.source,
                            restrictions: i.restrictions,
                            createdAt: i.createdAt
                        });
                    }
                    return result
                }, []);

                let wooTokens = []
                let shopifyTokens = []
                let gudangTokens = [];
                
                resTok.tokens.forEach(i => {
                    if (i.restrictions[0].type.includes('woocommerce')) {
                        wooTokens.push({
                            id: i._id,
                            name: i.name,
                            source: i.source,
                            restrictions: i.restrictions,
                            type: i.restrictions[0].type,
                            status: i.restrictions[0].status,
                            dueAt: i.restrictions[0].dueAt,
                            createdAt: i.createdAt
                        });
                    }
                    if (i.restrictions[0].type.includes('shopify')) {
                        shopifyTokens.push({
                            id: i._id,
                            name: i.name,
                            source: i.source,
                            restrictions: i.restrictions,
                            type: i.restrictions[0].type,
                            status: i.restrictions[0].status,
                            dueAt: i.restrictions[0].dueAt,
                            createdAt: i.createdAt
                        });
                    }
                    if (i.restrictions[0].type.includes('gudangio')) {
                        gudangTokens.push({
                            id: i._id,
                            name: i.name,
                            source: i.source,
                            restrictions: i.restrictions,
                            type: i.restrictions[0].type,
                            status: i.restrictions[0].status,
                            dueAt: i.restrictions[0].dueAt,
                            createdAt: i.createdAt
                        });
                    }
                });
                
                setTokens({
                    ...tokens,
                    app: resTokens,
                    woo: wooTokens,
                    shopify: shopifyTokens,
                    gudangio: gudangTokens
                })
            }

            if (resUs.success) {
                if (testData === 'active') {
                    setCallbackURL(resUs.webhooks.orderStatusTest)
                } else {
                    setCallbackURL(resUs.webhooks.orderStatus)
                }
            }

            setLoading(false)
        } catch (e) {
            console.log (e);
            alert("Gagal ambil token")
        }
    };

    const onDeleteToken = async (id) => {
        try {
            let resToken;
            if (window.confirm("Apakah Anda yakin mau hapus kunci API?")) {
                resToken = await deleteTokens(token, id);
            } else {
                return
            }

            if (resToken.success) {
                alert("Berhasil di delete");
                window.location.reload()
            } else {
                alert("Gagal delete API key")
            }
        } catch (e) {
            console.log (e);
            alert(`${e.message}`)
        }
    };

    const onExtendKey = async (id,type) => {
        setLoadingExtendKey({...loadingExtendKey,[type]:true})
        try {
            let resToken;
            if (window.confirm("Apakah Anda yakin ingin perpanjang layanan WooCommerce?")) {
                resToken = await extendKey(token,id)
            } else {
                return
            }

            if (resToken.success) {
                onOpenQR(resToken.id)
            } else {
                alert("Gagal delete API key")
            }
        } catch (e) {
            console.log (e);
            alert(`${e.message}`)
        }
    }

    const onDeleteIntegration = async (name) => {
        try {
            let resToken;
            if (window.confirm(`Apakah Anda yakin ingin memutuskan koneksi Jurnal?`)) {
                resToken = await deleteIntegrations(token);
            } else {
                return
            }

            if (resToken.success) {
                alert("Berhasil di delete");
                window.location.reload()
            } else {
                alert("Gagal memutuskan integrasi")
            }
        } catch (e) {
            console.log (e);
            alert(`${e.message}`)
        }
    }

    const onAddToken = async (t,channel) => {
        if (!user.phone) {
            alert("Mohon masukkan nomor telpon terlebih dahulu di pengaturan :)");
            return
        }
        
        setLoadingCreateKey(true)
        try {
            let type,name;

            let subsType;
            let nameType;
            if (subsModalType === 'woocommerce') {
                subsType = 'woocommerce';
                nameType = 'WooCommerce';
            } else if (subsModalType === 'shopify' || channel === 'shopify') {
                subsType = 'shopify';
                nameType = 'Shopify';
            } else if (subsModalType === 'gudangio') {
                subsType = 'gudangio';
                nameType = 'GudangIo';
            }

            switch (t) {
                case 'Free':
                    type = `${subsType}Free`;
                    name = `${nameType} Free`;
                    break;
                case 'Essentials':
                    type = `${subsType}Essentials`;
                    name = `${nameType} Essentials`;
                    break;
                case 'Standard':
                    type = `${subsType}Standard`;
                    name = `${nameType} Standard`;
                    break;
                case 'Premium':
                    type = `${subsType}Premium`;
                    name = `${nameType} Premium`;
                    break;
                case 'gudangio':
                    type = `gudangio`;
                    name = `GudangIo`;
                    break;
                case 'app':
                    type = 'Application'  
                    name = values.name  
                    break;
                default:
                    type = null
                    break;
            }

            const environment = testData == 'active' ? 'development' : 'production';
            const resToken = await createToken(token, name, type, environment );

            if (resToken.success) {
                trackEvent(`User Add ${type} Key`,{
                    action: "track",
                    category: "Keys",
                    label: `${type} Key Created`,
                    event: "Click"
                });

                if (t === 'gudangio') {
                    window.location.reload();
                } else {
                    window.location.assign('/integrations/'+resToken.token)
                }
                
            } else {
                alert("API key gagal dibuat")
            }
        } catch (e) {
            console.log (e);
            alert(`${e.message}`)
            setLoadingCreateKey(true)
        }
    }

    const onModalShow = () => {
        if (!user.phone) {
            alert("Mohon masukkan nomor telpon terlebih dahulu di pengaturan :)");
            return
        }

        if (!user.organizationName) {
            alert("Mohon masukkan nama perusahaan terlebih dahulu di pengaturan :)");
            return
        }

        setShowModal(true);
    };

    const onModalClose = () => {
        setShowModal(false);
    };

    const handleChange = name => e => {
        setValues({...values, [name]: e.target.value})
    };

    const modal = () => {
        return (
            <Modal
                show={showModal}
                onHide={onModalClose}
                title={"Buat Kunci API"}
                size={"sm"}
                bodyClassName="px-4 pt-4 pb-2"
                buttons
                type='oneButton'
                bText={"Buat Baru"}
                loading={loadingCreateKey}
                bClick={() => onAddToken('app')}
            >
                <div className="form">
                    <div className="form-group input-group-sm">
                        <input
                            type="text"
                            onChange={handleChange('name')}
                            placeholder="Nama API"
                            className="form-control mb-4"
                            value={values.name}
                            required
                        />
                    </div>
                </div>
            </Modal>
        )
    };

    let contentKey;
    if (tokens.app.length === 0) {
        contentKey = (
            <div className="text-center mt-4 pb-5">
                <h4>Anda belum punya kunci API</h4>
                <p>Generate kunci baru!</p>
                <button
                    onClick={onModalShow}
                    className="btn btn-primary col-3 mt-2">
                    Generate Kunci Api
                </button>
            </div>
        )
    } else {
        contentKey = (
            <div>
                <KeyTable
                    data={tokens.app}
                    user={user}
                    loading={loading}
                    onDeleteToken={onDeleteToken}
                />
            </div>
        )
    }

    const contentWebstore = (
        <div className="bg-white rounded shadow py-4">
            <div className="px-4">
                <h5>Toko Online</h5>
                <p>Hubungkan toko online Anda dengan Biteship</p>
            </div>
            <hr/>
            <ShopifyCard
                token={tokens.shopify[0]}
                onOpenQR={e => onOpenQR(e,'shopify')}
                onDeleteToken={e => onDeleteToken(e)}
                onExtendKey={e => onExtendKey(e,'shopify')}
                loadingExtendKey={loadingExtendKey.shopify}
                setModal={e => {setSubsModalType('shopify');onAddToken('Free','shopify')}}
            />
            <hr/>
            <WooCard
                token={tokens.woo[0]}
                onOpenQR={e => onOpenQR(e,'woo')}
                onDeleteToken={e => onDeleteToken(e)}
                onExtendKey={e => onExtendKey(e,'woo')}
                loadingExtendKey={loadingExtendKey.woo}
                setModal={e => {setSubsModalType('woocommerce');setSubsModal(e)}}
            />
        </div>
    )

    const contentFulfillment = (
        <div className="bg-white rounded shadow py-4">
            <div className="px-4">
                <h5>Layanan Fulfillment</h5>
                <p>Hubungkan layanan fulfillment Anda dengan Biteship</p>
            </div>
            <hr/>
            <GudangIoCard
                token={tokens.gudangio[0]}
                onOpenQR={e => onOpenQR(e,'woo')}
                onDeleteToken={e => onDeleteToken(e)}
                onExtendKey={e => onExtendKey(e,'woo')}
                loadingExtendKey={loadingExtendKey.woo}
                onClickActivate={e => {setSubsModalType('gudangio');onAddToken('gudangio')}}
            />
        </div>
    )

    const onOpenQR = async (keyId,type) => {
        setLoadingExtendKey({...loadingExtendKey,[type]:true})
        const res = await fetchKeyPaymentData(token, keyId);
        if (!res.success) {
          alert(`Failed to get QR Code`);
          return
        }
        setQrCode(res.qr_string);
        setQrModal(true);
        setLoadingExtendKey({...loadingExtendKey,[type]:false})
    };
    
    const modalQr = () => {
        return (
            <Modal
                show={qrModal}
                onHide={() =>  window.location.reload()}
                title={"Pembayaran QRIS WooCommerce"}
                size={"sm"}
                bodyClassName="py-4 text-center"
                buttons
            >
              <p> Silahkan lakukan pembayaran dengan scan QR code dibawah ini </p>
              <QRCode
                  size={156}
                  value={qrCode}
              />
              <br/>
              <p> Pembayaran QRIS dengan <b>scan QR Code</b> melalalui aplikasi OVO, Gojek, LinkAja dan lainnya yang mendukung teknologi QRIS.</p>
            </Modal>
        )
    };
    
    const contentApplication = (
        <div className="bg-white rounded shadow py-4">
            <div className="px-4">
                <h5>Aplikasi</h5>
                <p>Hubungkan Biteship dengan aplikasi yang Anda gunakan</p>
            </div>
            <hr/>
            <div className="px-5">
                <div className="row d-flex justify-content-between">
                    <img 
                        style={{height:48}} 
                        src={`/images/logos/jurnal.png`} 
                        alt={`Biteship WooCommerce`}
                    />
                    {
                        integrations.filter(i => i.name === 'jurnal').length > 0 ? 
                            <div className="pr-4 p-1 float-right d-flex">
                                <div className="pt-2 pr-4">✅ <b>Sudah Terkoneksi</b></div>
                                <button
                                    onClick={() => onDeleteIntegration('jurnal')}
                                    className="btn btn-outline-primary btn-sm"
                                >
                                    Putus Koneksi
                                </button>
                            </div> 
                            :
                            <div className="input-group-sm col-2">
                                <button 
                                    onClick={() => window.open("https://my.jurnal.id/authorize_apps/new?client_id=8ca38a1b3c5d40689734fba2e57a5def")}
                                    type="submit" 
                                    class="btn btn-sm btn-primary"
                                >
                                    Aktifkan 
                                </button>
                            </div>
                    }
                
                </div>
            </div>
        </div>
    )

    if (loading) {
        return (
            <div>
                <TestDataWarning/>
                <div className="bg-white rounded shadow">
                <div className="p-4">
                    <h5>Kunci API</h5>
                    <div className="py-4">Loading...</div>
                </div>
            </div>
            </div>
        )
    }
    return (
        <div>
            <PaymentWarning user={user} type={"top"}/>
            <TestDataWarning/>
            <SubscriptionModal
                show={subsModal}
                type={subsModalType}
                loading={loadingCreateKey}
                onHide={() => setSubsModal(false)}
                onClick={ e => onAddToken(e)}
            />
            { modalQr() }
            { modal() }
            <div className="bg-white border-warning rounded shadow">
                <div className="p-4">
                    <div className=" d-flex justify-content-between">
                        <h5>Kunci API </h5>
                        <div className="d-flex">
                            {
                                props.wallet.type === 'requested' ?
                                    null
                                    :
                                    props.wallet.type === 'prepaid' &&  testData === 'notActive' && tokens.app.length !== 0?
                                        <div>
                                            <button
                                                className="btn btn-sm btn-primary mr-4"
                                                onClick={() => window.location.assign('/api-production-form')}
                                            >
                                                Aktivasi Live API
                                            </button>
                                        </div>
                                        :
                                        null
                            }
                            {
                                tokens.app.length === 0 ? '' :
                                    <button
                                        className="btn btn-sm btn-primary"
                                        onClick={onModalShow}
                                    >
                                        Tambah Kunci
                                    </button>
                            }
                        </div>
                   
                    </div>
                </div>
                { contentKey }
            </div>
            <br/>
            <WebhookTable data={webhooks}/>
            <br/>
            { testData === 'active' ? '' : contentWebstore }
            <br/>
            { testData === 'active' ? '' : contentFulfillment }
            <br/>
            { testData === 'active' ? '' : contentApplication }
            <br/>
            <br/>
        </div>

    )
};


export default connect(state => ({ wallet: state.wallet}), {})(Setting)